import { render, staticRenderFns } from "./orderModal.vue?vue&type=template&id=61a96735&scoped=true&"
import script from "./orderModal.vue?vue&type=script&lang=js&"
export * from "./orderModal.vue?vue&type=script&lang=js&"
import style0 from "./orderModal.vue?vue&type=style&index=0&id=61a96735&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61a96735",
  null
  
)

export default component.exports